import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import UpArrow from "../../common/ArrowUp";
import DownArrow from "../../common/ArrowDown";
import LinkModal from "../../common/LinkModal";

const ClaimSubmissionGuideline = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const containerRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const openLinkModal = e => {
    e.preventDefault();
    setLinkUrl(e.target.href);
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setLinkUrl("");
    setIsOpenModal(false);
  };

  useEffect(() => {
    const containerElement = containerRef.current;
    if (containerElement) {
      containerElement.addEventListener("click", openLinkModal);
    }

    return () => {
      if (containerElement) {
        containerElement.removeEventListener("click", openLinkModal);
      }
    };
  }, []); // Run this effect only once on mount

  return (
    <div ref={containerRef}>
      <button className="link" onClick={toggleAccordion} style={{ textAlign: "left" }}>
        {title}{" "}
        {isOpen ? <UpArrow width="14px" height="14px" /> : <DownArrow width="16px" height="16px" />}
      </button>
      {isOpen && <div>{children}</div>}
      {isOpenModal && (
        <div>
          {linkUrl && <LinkModal isOpen={isOpenModal} closeModal={closeModal} linkUrl={linkUrl} />}
        </div>
      )}
    </div>
  );
};

ClaimSubmissionGuideline.propTypes = {
  title: PropTypes.string,
  children: PropTypes.string,
};

export default ClaimSubmissionGuideline;



// WEBPACK FOOTER //
// ./components/claim/widgets/ClaimSubmissionGuideline.js